import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import RecommendationMainDetails from "./InfoPages/RecommendationMainDetails";
import InfoTabs from "../../common/components/InfoTabs";
import InfoImages from "../../common/components/InfoImages1";
import { LOCK_STATUS, RECOMMENDATION_SOURCE_TYPES, RECOMMENDATION_TYPES, entities } from "../../common/constants";
import RecommendationAssetDetails from "../../common/components/RecommendationAssetDetails";
import {
    addToBreadCrumpData,
    bulkResetBreadCrumpData,
    checkPermission,
    getTableSliderData,
    normalizeToNested,
    popBreadCrumpRecData
} from "../../../config/utils";
import ReactTooltip from "react-tooltip";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../common/components/Loader";
import Documents from "../../documents/index";
import CapitalRequest from "../../capitalRequest/index";
import QaQcBand from "./QaQcBand";
import Portal from "../../common/components/Portal";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import AddIssueModal from "../../common/components/AddIssueModal";
import qs from "query-string";
import Recommendations from "../index";
import MobileRecommendationsMain from "../../mobileRecommendation/components/MobileRecommendationsMain";
import { permissions } from "../../../config/permissions";
import SoftCosts from "../../softCosts/SoftCosts";
import statusActions from "../../Status/action";
import { connect } from "react-redux";
import { RecommendationChecklist } from "./Bands/Checklist";
import { getCapitalRequestLabel } from "../../../utils/capitalRequestLabel";
import { getReviewGateStatus, REVIEW_GATE_STATUS } from "../utils/qaGateValidation";

class RecommendationsInfo extends Component {
    state = {
        loading: true,
        isloading: true,
        basicDetails: {
            id: "",
            code: "",
            description: "",
            trade: "",
            system: "",
            sub_system: "",
            building: "",
            floor: "",
            addition: "",
            department: "",
            hospital_name: "",
            category: "",
            room: "",
            asset_name: "",
            asset_tag: "",
            asset_notes: "",
            installed_year: "",
            current_age: "",
            end_of_service_life: "",
            notes: "",
            note_html: "",
            condition: "",
            priority: "",
            funding: "",
            space_type: null,
            responsibility: "",
            deffered_maintenance: "",
            future_capital: "",
            inspection_date: "",
            project_total: "",
            project_costs: "",
            surveyor: "",
            surveyor_id: "",
            status: "",
            status_notes: "",
            cr_status: "",
            cr_status_notes: "",
            image: "",
            capital_type_display_name: "",
            capital_type: "",
            recommendation_capital_type_id: "",
            initiative: "",
            budget_priority: "",
            infrastructure_request: "",
            serial_number: "",
            priority_elements: [
                { index: "1", element: "" },
                { index: "2", element: "" },
                { index: "3", element: "" },
                { index: "4", element: "" },
                { index: "5", element: "" },
                { index: "6", element: "" },
                { index: "7", element: "" },
                { index: "8", element: "" }
            ],
            priority_elements_data: [],
            maintenance_years: [],
            asset: {},
            recommendation_type: "",
            fmp: "",
            fmp_id: "",
            fmp_project: "",
            fmp_track: "",
            red_line: "",
            continuous_fca: "",
            criticality: "",
            criticality_type: "",
            source: "",
            energy_band: {},
            water_band: {},
            energy_band_show: "no",
            water_band_show: "no",
            locked: false,
            dynamic_fields: {},
            showQaQcBand: !localStorage.getItem("role") === "client_user",
            isQaQcReviewerUser: localStorage.getItem("role") === "super_admin",
            birth_year: "",
            years_with_value: "",
            requestor: "",
            requested_date: "",
            is_survey_lock: false
        },
        imageList: [],
        infoTabsData: [
            {
                key: "maindetails",
                name: "Main Details",
                path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/maindetails`
            },
            {
                key: "infoimages",
                name: "Images",
                path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/infoimages`,
                show: checkPermission("forms", permissions.RECOMMENDATION_IMAGES, "view")
            },
            ...getQaQcTabEntries(this.props.match.params.id, this.props.location?.search || "", {
                isQaQcReviewerUser: localStorage.getItem("role") === "super_admin"
            }),
            {
                key: "documents",
                name: "Documents",
                path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/documents`
            }
        ],
        staticLinking: {
            energy: false,
            water: false
        },
        checklistData: [],
        qaQcAddIssueModalFromInfoTabs: false,
        qaQcReopenConfirmFromInfoTabs: false
    };

    componentDidMount = async () => {
        await this.refreshinfoDetails();
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            if (
                ![prevProps.match.params.tab, this.props.match.params.tab].includes("linked-cr-recommendations") &&
                ![prevProps.match.params.tab, this.props.match.params.tab].includes("linked-recommendations") &&
                ![prevProps.match.params.tab, this.props.match.params.tab].includes("mobile-recommendations")
            ) {
                const {
                    location: { search = "" }
                } = this.props;
                const currentParams = qs.parse(search);
                this.props.showInfoPage(this.props.match.params.id, null, null, currentParams?.is_cr, currentParams?.is_mr);
            }
            await this.refreshinfoDetails();
            this.setState({
                qaQcAddIssueModalFromInfoTabs: false,
                qaQcReopenConfirmFromInfoTabs: false
            });
        }
        if (prevProps.match.params.tab !== this.props.match.params.tab) {
            if (this.props.match.params.tab === "maindetails") {
                await this.refreshinfoDetails();
            }
            if (this.state.basicDetails?.showQaQcBand) {
                await this.props.getQaQcData({
                    recommendation_id: this.props.match.params.id,
                    order: {
                        [`recommendation_reviews.created_at`]: "desc"
                    }
                });
            }
        }
    };

    handleAddNewQaQcIssueFromMenu = () => {
        const status = getReviewGateStatus(this.props.recommendationsReducer?.getRecommendationByIdResponse);
        if (status === REVIEW_GATE_STATUS.QA_PASSED || status === REVIEW_GATE_STATUS.READY_FOR_QA) {
            this.setState({ qaQcReopenConfirmFromInfoTabs: true });
        } else {
            this.setState({ qaQcAddIssueModalFromInfoTabs: true });
        }
    };

    closeQaQcAddIssueModalFromInfoTabs = () => this.setState({ qaQcAddIssueModalFromInfoTabs: false });

    setTabs = () => {
        const {
            location: { search = "" },
            projectData
        } = this.props;
        const isCapitalRequest = qs.parse(search)?.is_cr === "true";
        const isMobileRecommendation = qs.parse(search)?.is_mr === "true";
        const isCrUser = localStorage.getItem("infrastructure_request_user") === "yes";
        const crLabel = getCapitalRequestLabel(projectData?.miscellaneous);

        const showQaQcBandTab = getQaQcTabEntries(this.props.match.params.id, search, this.state.basicDetails);
        if (this.state.basicDetails.recommendation_type === RECOMMENDATION_TYPES.ASSET) {
            this.setState({
                infoTabsData: [
                    {
                        key: "maindetails",
                        name: "Recommendation",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/maindetails${search}`
                    },
                    {
                        key: "assetdetails",
                        name: "Asset Details",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/assetdetails${search}`
                    },
                    ...(projectData?.miscellaneous?.checklist_survey
                        ? [
                              {
                                  key: "checklists",
                                  name: "Checklists",
                                  path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/checklists${search}`
                              }
                          ]
                        : []),
                    {
                        key: "infoimages",
                        name: "Images",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/infoimages${search}`,
                        show: checkPermission("forms", permissions.RECOMMENDATION_IMAGES, "view")
                    },
                    ...showQaQcBandTab,
                    {
                        key: "documents",
                        name: "Documents",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/documents${search}`
                    },
                    ...(!isCapitalRequest
                        ? [
                              {
                                  key: "mobile-recommendations",
                                  name: "Mobile Recommendations",
                                  path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/mobile-recommendations${search}`
                              }
                          ]
                        : []),
                    ...(isCrUser || isCapitalRequest || isMobileRecommendation
                        ? []
                        : [
                              {
                                  key: "linked-cr-recommendations",
                                  name: crLabel,
                                  path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/linked-cr-recommendations${search}`
                              }
                          ]),
                    {
                        key: "softCosts",
                        name: "Project Costs",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/softCosts${search}`,
                        show: checkPermission("forms", permissions.SOFT_COSTS, "view")
                    }
                ]
            });
        } else {
            this.setState({
                infoTabsData: [
                    {
                        key: "maindetails",
                        name: isCapitalRequest ? crLabel : "Recommendation",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/maindetails${search}`
                    },
                    ...(projectData?.miscellaneous?.checklist_survey
                        ? [
                              {
                                  key: "checklists",
                                  name: "Checklists",
                                  path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/checklists${search}`
                              }
                          ]
                        : []),
                    {
                        key: "infoimages",
                        name: "Images",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/infoimages${search}`,
                        show: checkPermission("forms", permissions.RECOMMENDATION_IMAGES, "view")
                    },
                    ...(isCapitalRequest ? [] : showQaQcBandTab),
                    {
                        key: "documents",
                        name: "Documents",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/documents${search}`
                    },
                    ...(!isCapitalRequest && ((qs.parse(search)?.is_assignedRecom && qs.parse(search)?.is_mr) || !qs.parse(search)?.is_assignedRecom)
                        ? [
                              {
                                  key: "mobile-recommendations",
                                  name: "Mobile Recommendations",
                                  path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/mobile-recommendations${search}`
                              }
                          ]
                        : []),
                    ...(isCrUser
                        ? []
                        : isCapitalRequest
                          ? [
                                {
                                    key: "linked-recommendations",
                                    name: "Recommendations",
                                    path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/linked-recommendations${search}`
                                }
                            ]
                          : isMobileRecommendation
                            ? [
                                  //   {
                                  //       key: "mobile-recommendations",
                                  //       name: "Mobile Recommendations",
                                  //       path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/mobile-recommendations${search}`
                                  //   }
                              ]
                            : [
                                  {
                                      key: "linked-cr-recommendations",
                                      name: crLabel,
                                      path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/linked-cr-recommendations${search}`
                                  }
                              ]),

                    {
                        key: "softCosts",
                        name: "Project Costs",
                        path: `/recommendations/recommendationsinfo/${this.props.match.params.id}/softCosts${search}`,
                        show: checkPermission("forms", permissions.SOFT_COSTS, "view")
                    }
                ]
            });
        }
    };

    setMailBreadcrumbData = recommendationsData => {
        const {
            location: { search = "" },
            match: {
                params: { id, tab = "maindetails" }
            }
        } = this.props;
        const query = qs.parse(search);
        const currentBreadCrumbs = JSON.parse(sessionStorage.getItem("bc-data") || "[]");
        const hasBreadCrumbTrail = Array.isArray(currentBreadCrumbs) && currentBreadCrumbs.length >= 2;
        if (query?.from_mail !== "true" && hasBreadCrumbTrail) return;

        const projectId = query?.p_id || recommendationsData?.project?.id;
        if (!projectId) return;

        const projectName = query?.p_name || recommendationsData?.project?.name || recommendationsData?.project?.project_name || "Project";
        const recommendationCode = recommendationsData?.code || "Recommendation";
        const infoPath = `/recommendations/recommendationsinfo/${id}/${tab}${search}`;
        const mainDetailsPath = `/recommendations/recommendationsinfo/${id}/maindetails${search}`;

        const isCapitalRequest = query?.is_cr === "true";
        const crLabel = getCapitalRequestLabel(this.props.projectData?.miscellaneous);
        const listTabName = isCapitalRequest ? crLabel : "Recommendations";
        const listTabPath = isCapitalRequest
            ? `/project/projectinfo/${projectId}/cr-recommendations`
            : `/project/projectinfo/${projectId}/recommendations`;

        bulkResetBreadCrumpData([
            { key: "main", name: "FCA Projects", path: "/project" },
            { key: "buildingName", name: projectName, path: `/project/projectinfo/${projectId}/basicdetails` },
            { key: "info", name: listTabName, path: listTabPath },
            { key: "Name", name: recommendationCode, path: mainDetailsPath },
            { key: "info", name: "Main Details", path: infoPath }
        ]);
    };

    refreshinfoDetails = async () => {
        this.setState({
            loading: true
        });
        const {
            match: {
                params: { tab }
            }
        } = this.props;
        const recommendationsData = await this.props.getDataById(this.props.match.params.id);
        const [priorityElementsData] = await Promise.all([
            this.props.getPriorityElementDropDownData(recommendationsData.project?.id || ""),
            this.props.getProjectById(recommendationsData.project?.id || ""),
            this.props.getDynamicFields({ client_id: recommendationsData.client?.id, project_id: recommendationsData.project?.id })
        ]);
        if (tab === "maindetails") {
            this.props?.statusDropdown(recommendationsData.project?.id);
        }

        let showQaQcBand = localStorage.getItem("role") !== "client_user";
        let isQaQcReviewerUser = localStorage.getItem("role") === "super_admin";
        if (!isQaQcReviewerUser) {
            const userProjectReviewerData = await this.props.isProjectReviewer({
                project_id: recommendationsData.project?.id || "",
                user_id: localStorage.getItem("userId") || "",
                is_active: true
            });
            isQaQcReviewerUser = userProjectReviewerData;
        }
        showQaQcBand = showQaQcBand || isQaQcReviewerUser;
        if (showQaQcBand) {
            await this.props.getQaQcData({
                recommendation_id: this.props.match.params.id,
                order: {
                    [`recommendation_reviews.created_at`]: "desc"
                }
            });
        }
        const { recommendation_custom_fields: bands = [] } = this.props.recommendationsReducer.dynamicFields;
        let tempStaticLinking = { ...this.state.staticLinking };

        Object.entries(bands).forEach(([band, fields]) => {
            if (fields.some(e => e?.link_static_entity === "energy")) {
                tempStaticLinking = { ...tempStaticLinking, energy: true };
            }
            if (fields.some(e => e?.link_static_entity === "water")) {
                tempStaticLinking = { ...tempStaticLinking, water: true };
            }
        });
        await this.setState({ staticLinking: tempStaticLinking });
        this.props.getAllImageList(this.props.match.params.id, {
            limit: 100,
            offset: 1,
            image_sort: recommendationsData.image_sort
        });
        if (recommendationsData && recommendationsData.success) {
            this.setState(
                {
                    basicDetails: {
                        id: recommendationsData.id,
                        code: recommendationsData.code,
                        description: recommendationsData.description,
                        trade: recommendationsData.trade,
                        system: recommendationsData.system,
                        sub_system: recommendationsData.sub_system,
                        client: recommendationsData.client,
                        consultancy: recommendationsData.consultancy,
                        region: recommendationsData.region,
                        site: recommendationsData.site,
                        project: recommendationsData.project,
                        building: recommendationsData.building,
                        floor: recommendationsData.floor,
                        addition: recommendationsData.addition,
                        hospital_name: recommendationsData.building.hospital_name,
                        department: recommendationsData.department,
                        category: recommendationsData.category,
                        room: recommendationsData.room,
                        asset_name: recommendationsData.asset_name,
                        asset_tag: recommendationsData.asset_tag,
                        asset_notes: recommendationsData.asset_notes,
                        installed_year: recommendationsData.installed_year,
                        current_age: recommendationsData.current_age,
                        end_of_service_life: recommendationsData.end_of_service_life,
                        notes: recommendationsData.notes,
                        note_html: recommendationsData.note_html || recommendationsData.notes?.replace(/\n/g, "<br />"),
                        condition: recommendationsData.condition,
                        priority: recommendationsData.priority,
                        funding: recommendationsData.funding,
                        responsibility: recommendationsData.responsibility,
                        deffered_maintenance: recommendationsData.deffered_maintenance,
                        future_capital: recommendationsData.future_capital,
                        inspection_date: recommendationsData.inspection_date,
                        inspection_time: recommendationsData.inspection_time,
                        project_total: recommendationsData.project_total,
                        project_costs: recommendationsData.project_costs,
                        surveyor: recommendationsData.surveyor,
                        surveyor_id: recommendationsData.surveyor_id,
                        status: recommendationsData.status,
                        status_notes: recommendationsData.status_notes,
                        cr_status: recommendationsData.cr_status,
                        cr_status_notes: recommendationsData.cr_status_notes,
                        initiative: recommendationsData.initiative,
                        capital_type_display_name: recommendationsData.capital_type_display_name,
                        capital_type: recommendationsData.capital_type,
                        recommendation_capital_type_id: recommendationsData.recommendation_capital_type_id,
                        priority_elements: recommendationsData.priority_elements,
                        priority_elements_data: [
                            ...priorityElementsData.priority_elements,
                            ...recommendationsData.priority_elements.slice(
                                priorityElementsData.priority_elements.length,
                                recommendationsData.priority_elements.length
                            )
                        ],
                        maintenance_years: recommendationsData.maintenance_years,
                        image: recommendationsData.image,
                        image_sort: recommendationsData.image_sort,
                        capacity: recommendationsData.capacity,
                        service_life: recommendationsData.service_life,
                        usefull_life_remaining: recommendationsData.usefull_life_remaining,
                        crv: recommendationsData.crv,
                        serial_number: recommendationsData.serial_number,
                        model_number: recommendationsData.model_number,
                        created_at: recommendationsData.created_at,
                        updated_at: recommendationsData.updated_at,
                        area_served: recommendationsData.area_served,
                        funding_source: recommendationsData.funding_source,
                        space_type: recommendationsData.recommendation_space_type,
                        locked: recommendationsData.lock_status === LOCK_STATUS.LOCKED,
                        is_survey_lock: recommendationsData?.is_survey_lock,
                        deleted: recommendationsData.deleted,
                        essential: recommendationsData.essential,
                        manufacturer: recommendationsData.manufacturer?.name,
                        quantity: recommendationsData.quantity,
                        unit: recommendationsData.unit,
                        cost_per_unit: recommendationsData.cost_per_unit,
                        options_cost: recommendationsData.options_cost,
                        budget_priority: recommendationsData.budget_priority,
                        asset: recommendationsData.asset,
                        recommendation_type: recommendationsData.recommendation_type || RECOMMENDATION_TYPES.SYSTEM,
                        fmp: recommendationsData.fmp,
                        fmp_id: recommendationsData.fmp_id,
                        fmp_project: recommendationsData.fmp_project,
                        fmp_track: recommendationsData.fmp_track,
                        infrastructure_request: recommendationsData.infrastructure_request,
                        red_line: recommendationsData.red_line,
                        continuous_fca: recommendationsData.continuous_fca,
                        criticality: recommendationsData.criticality || "-",
                        criticality_type: recommendationsData.criticality_type || "-",
                        source: recommendationsData.source || "-",
                        energy_band: recommendationsData.energy_band,
                        water_band: recommendationsData.water_band,
                        energy_band_show: recommendationsData.energy_band_show,
                        water_band_show: recommendationsData.water_band_show,
                        dynamic_fields: recommendationsData?.dynamic_fields,
                        showQaQcBand,
                        isQaQcReviewerUser,
                        birth_year: recommendationsData?.birth_year,
                        years_with_value: recommendationsData?.years_with_value,
                        requestor: recommendationsData.requestor,
                        requested_date: recommendationsData?.requested_date,
                        occurrence: recommendationsData?.occurrence,
                        total_opinions_of_cost: recommendationsData?.total_opinions_of_cost
                    },
                    checklistData: normalizeToNested(recommendationsData?.check_list || []),
                    isloading: false
                },
                () => {
                    this.setMailBreadcrumbData(recommendationsData);
                    this.setTabs();
                }
            );
        }
        this.setState({
            loading: false
        });
        return true;
    };

    uploadImages = async imageData => {
        this.setState({
            isloading: true
        });
        await this.props.uploadImages(imageData);
        await this.refreshinfoDetails();
    };

    deleteImage = async imageId => {
        this.setState({
            loading: true
        });
        await this.props.deleteImages(imageId);
        await this.refreshinfoDetails();
    };

    updateImage = async imageData => {
        this.setState({
            isloading: true
        });
        await this.props.updateRecommendationImageComment(imageData);
        await this.refreshinfoDetails();
    };
    setSelectedImage = async i => {
        const { imageList } = this.state;
        await this.setState({
            selectedImage: { image: imageList[i], index: i }
        });
    };

    handleAssignToRecom = async imgData => {
        let res = await this.props.assignImagesToRecom(imgData);
        await this.refreshinfoDetails();
        return res;
    };
    updateBudgetPriority = async (params, id) => {
        this.props.updateBudget(params, id);
        this.setState({ basicDetails: { ...this.state.basicDetails, budget_priority: params.budget_priority } });
    };
    updateImageSort = async (id, params) => {
        await this.props.updateRecommendationImageSort(id, params);
        this.setState({ basicDetails: { ...this.state.basicDetails, image_sort: params.image_sort } });
        return true;
    };
    updateFMP = (params, id) => {
        this.props.updateFMP(params, id);
        this.setState({ basicDetails: { ...this.state.basicDetails, fmp: params.fmp } });
    };
    updateIR = (params, id) => {
        this.props.updateIR(params, id);
        this.setState({ basicDetails: { ...this.state.basicDetails, infrastructure_request: params.infrastructure_request } });
    };
    updateRL = (params, id) => {
        this.props.updateRL(params, id);
        this.setState({ basicDetails: { ...this.state.basicDetails, red_line: params.red_line } });
    };
    updateContinuousFCA = (params, id) => {
        this.props.updateContinuousFCA(params, id);
        this.setState({ basicDetails: { ...this.state.basicDetails, continuous_fca: params.continuous_fca } });
    };
    handleNext = id => {
        const {
            location: { search = "" },
            match: {
                params: { tab }
            },
            tableData
        } = this.props;
        const { infoTabsData } = this.state;
        let current_index = tableData?.findIndex(item => item.id === id);
        const tableSliderData = getTableSliderData();
        const query = qs.parse(search);
        const isAssignedRecom = qs.parse(search)?.is_assignedRecom === "true";
        if (!isAssignedRecom || (isAssignedRecom && query?.is_mr)) popBreadCrumpRecData();
        addToBreadCrumpData({
            key: "Name",
            name: tableData[current_index + 1].code,
            path: `/recommendations/recommendationsinfo/${tableData[current_index + 1].id}/maindetails${search}`,
            tableSliderData
        });
        addToBreadCrumpData({
            key: "info",
            name: infoTabsData.find(elem => elem.key === tab)?.name,
            path: `/recommendations/recommendationsinfo/${tableData[current_index + 1].id}/${tab}${search}`
        });
        this.props.history.push(`/recommendations/recommendationsinfo/${tableData[current_index + 1].id}/${tab}${search}`);
        this.props.updateSelectedRow(tableData[current_index + 1].id);
    };
    handlePrev = id => {
        const {
            location: { search = "" },
            match: {
                params: { tab }
            },
            tableData
        } = this.props;
        const { infoTabsData } = this.state;
        let current_index = tableData?.findIndex(item => item.id === id);
        const tableSliderData = getTableSliderData();
        const query = qs.parse(search);
        const isAssignedRecom = qs.parse(search)?.is_assignedRecom === "true";
        if (!isAssignedRecom || (isAssignedRecom && query?.is_mr)) popBreadCrumpRecData();
        addToBreadCrumpData({
            key: "Name",
            name: tableData[current_index - 1].code,
            path: `/recommendations/recommendationsinfo/${tableData[current_index - 1].id}/maindetails${search}`,
            tableSliderData
        });
        addToBreadCrumpData({
            key: "info",
            name: infoTabsData.find(elem => elem.key === tab)?.name,
            path: `/recommendations/recommendationsinfo/${tableData[current_index - 1].id}/${tab}${search}`
        });
        this.props.history.push(`/recommendations/recommendationsinfo/${tableData[current_index - 1].id}/${tab}${search}`);
        this.props.updateSelectedRow(tableData[current_index - 1].id);
    };

    lockRecommendation = () => {
        const { basicDetails } = this.state;
        this.setState({
            basicDetails: { ...basicDetails, locked: !basicDetails.locked }
        });
        this.props.lockRecommendation(!basicDetails.locked);
    };

    addClick = (basicDetails, type = RECOMMENDATION_SOURCE_TYPES.REGULAR) => {
        const {
            location: { search = "" }
        } = this.props;
        if (this.props.match.params.id && basicDetails?.project?.id) {
            if (type !== RECOMMENDATION_SOURCE_TYPES.REGULAR) {
                sessionStorage.setItem("currentRecommendationData", JSON.stringify(basicDetails));
            }
            const currentParams = qs.parse(search);
            const newParams = {
                ...currentParams,
                p_id: basicDetails?.project?.id,
                c_id: basicDetails?.client?.id,
                type: type,
                source_recommendation_id: type !== RECOMMENDATION_SOURCE_TYPES.REGULAR ? basicDetails?.id : undefined
            };

            const isCapitalRequest = qs.parse(search)?.is_cr === "true";
            const crLabel = getCapitalRequestLabel(this.props.projectData?.miscellaneous);
            const newPath = `/recommendations/add?${qs.stringify(newParams)}`;

            addToBreadCrumpData({
                key: "add",
                name: isCapitalRequest ? `Add ${crLabel}` : `Add Recommendation`,
                path: newPath
            });

            this.props.history.push(newPath);
        }
    };

    render() {
        const { isLoading } = this.state;
        if (isLoading) {
            return null;
        }

        const {
            keys,
            config,
            match: {
                params: { tab }
            },
            getAllSettingsLogs,
            logData,
            handlePerPageChangeHistory,
            handlePageClickHistory,
            handleGlobalSearchHistory,
            globalSearchKeyHistory,
            handleDeleteLog,
            historyPaginationParams,
            handleRestoreLog,
            historyParams,
            updateLogSortFilters,
            logPermission,
            imageResponse,
            getAllImageList,
            hasDelete,
            hasEdit,
            hasLogView,
            hasLogDelete,
            hasLogRestore,
            hasInfoPage,
            hasCreate,
            downloadPdfReport,
            entity,
            postExport,
            hasExport
        } = this.props;

        const { basicDetails, infoTabsData } = this.state;
        const {
            location: { search = "" }
        } = this.props;
        const isCapitalRequest = qs.parse(search)?.is_cr === "true";
        const crLabel = getCapitalRequestLabel(this.props.projectData?.miscellaneous);
        const isMobileRecommendation = qs.parse(search)?.is_mr === "true";
        const isAssignedRecom = qs.parse(search)?.is_assignedRecom === "true";
        const groupedOptions = (this.props?.recommendationStatusReducer?.getStatusDropdwnResponse?.recommendation_status_data || [])
            .reduce((acc, item) => {
                if (item?.key === "deleted") return acc;
                const groupName = item?.group_name || "Others";

                let group = acc.find(g => g?.label === groupName);
                if (!group) {
                    group = { label: groupName, options: [] };
                    acc.push(group);
                }
                group.options.push({
                    label: item?.name,
                    value: item?.id,
                    description: item?.description,
                    key: item?.key
                });

                return acc;
            }, [])
            ?.sort((a, b) => {
                return (a.label === "Others") - (b.label === "Others") || a.label.localeCompare(b.label);
            });

        const infoTabsIsQaQcReviewerUser =
            isCapitalRequest || (isAssignedRecom && !isMobileRecommendation) ? false : Boolean(basicDetails?.isQaQcReviewerUser);
        const canAddNewQaQcIssue = Boolean(basicDetails) && infoTabsIsQaQcReviewerUser && !basicDetails.locked && !basicDetails?.is_survey_lock;

        return (
            <LoadingOverlay active={this.state.loading} spinner={<Loader />} fadeSpeed={10}>
                <React.Fragment>
                    <div className="dtl-sec col-md-12">
                        <div className={`tab-dtl region-mng lockset ${tab === "qaqc" ? "qa-band-tab" : ""}`}>
                            <InfoTabs
                                infoTabsData={infoTabsData}
                                basicDetails={basicDetails}
                                lockItem={this.lockRecommendation}
                                createNewData={this.addClick}
                                hasCreate={
                                    hasCreate &&
                                    tab !== "linked-recommendations" &&
                                    !isMobileRecommendation
                                }
                                isRecommendation
                                entityName={isCapitalRequest ? crLabel : "Recommendation"}
                                isQaQcReviewerUser={infoTabsIsQaQcReviewerUser}
                                qaqcPendingStatus={this.props.qaqcPendingStatus}
                                CrBasedRecommendationBtn={isCapitalRequest && tab === "maindetails"}
                                createRecommendationFromCr={this.props?.createRecommendationFromCr}
                                recommendationDetails={basicDetails}
                                isNoramlRecom={!isCapitalRequest}
                                hasLock={true}
                                canAddNewQaQcIssue={canAddNewQaQcIssue}
                                onAddNewQaQcIssue={this.handleAddNewQaQcIssueFromMenu}
                            />
                            {tab === "maindetails" ? (
                                <RecommendationMainDetails
                                    keys={keys}
                                    config={config}
                                    basicDetails={basicDetails}
                                    deleteRecommendation={this.props.showDeleteBox}
                                    restoreRecommendation={this.props.showRestoreBox}
                                    getAllSettingsLogs={getAllSettingsLogs}
                                    handlePerPageChangeHistory={handlePerPageChangeHistory}
                                    handlePageClickHistory={handlePageClickHistory}
                                    handleGlobalSearchHistory={handleGlobalSearchHistory}
                                    globalSearchKeyHistory={globalSearchKeyHistory}
                                    logData={logData}
                                    handleDeleteLog={handleDeleteLog}
                                    historyPaginationParams={historyPaginationParams}
                                    HandleRestoreSettingsLog={handleRestoreLog}
                                    refreshinfoDetails={this.refreshinfoDetails}
                                    historyParams={historyParams}
                                    updateLogSortFilters={updateLogSortFilters}
                                    permissions={permissions}
                                    logPermission={logPermission}
                                    hasDelete={hasDelete}
                                    hasEdit={hasEdit}
                                    hasLogView={hasLogView}
                                    hasLogDelete={hasLogDelete}
                                    hasLogRestore={hasLogRestore}
                                    hasInfoPage={hasInfoPage}
                                    hasExport={hasExport}
                                    downloadPdfReport={downloadPdfReport}
                                    entity={entity}
                                    updateBudget={this.updateBudgetPriority}
                                    updateFMP={this.updateFMP}
                                    updateIR={this.updateIR}
                                    updateRL={this.updateRL}
                                    updateContinuousFCA={this.updateContinuousFCA}
                                    postExport={postExport}
                                    exportLoader={this.props.exportLoader}
                                    updateImageComment={this.props.updateRecommendationImageComment}
                                    deleteImage={this.deleteImage}
                                    imageResponse={imageResponse}
                                    refreshImageList={() =>
                                        this.props.getAllImageList(this.props.match.params.id, {
                                            limit: 100,
                                            offset: 1,
                                            image_sort: this.state.basicDetails?.image_sort
                                        })
                                    }
                                    isCapitalRequest={isCapitalRequest}
                                    groupedStatusOptions={groupedOptions}
                                    staticLinking={this.state.staticLinking}
                                    isAssignedRecom={isAssignedRecom}
                                />
                            ) : tab === "assetdetails" ? (
                                <RecommendationAssetDetails
                                    keys={keys}
                                    config={config}
                                    basicDetails={basicDetails}
                                    deleteRecommendation={this.props.showDeleteBox}
                                    restoreRecommendation={this.props.showRestoreBox}
                                    getAllSettingsLogs={getAllSettingsLogs}
                                    handlePerPageChangeHistory={handlePerPageChangeHistory}
                                    handlePageClickHistory={handlePageClickHistory}
                                    handleGlobalSearchHistory={handleGlobalSearchHistory}
                                    globalSearchKeyHistory={globalSearchKeyHistory}
                                    logData={logData}
                                    handleDeleteLog={handleDeleteLog}
                                    historyPaginationParams={historyPaginationParams}
                                    HandleRestoreSettingsLog={handleRestoreLog}
                                    refreshinfoDetails={this.refreshinfoDetails}
                                    historyParams={historyParams}
                                    updateLogSortFilters={updateLogSortFilters}
                                    permissions={permissions}
                                    logPermission={logPermission}
                                    hasDelete={hasDelete}
                                    hasEdit={hasEdit}
                                    hasLogView={hasLogView}
                                    hasLogDelete={hasLogDelete}
                                    hasLogRestore={hasLogRestore}
                                    hasInfoPage={hasInfoPage}
                                    downloadPdfReport={downloadPdfReport}
                                    entity={entity}
                                    updateBudget={this.updateBudgetPriority}
                                    updateFMP={this.updateFMP}
                                    updateIR={this.updateIR}
                                    updateRL={this.updateRL}
                                    updateContinuousFCA={this.updateContinuousFCA}
                                    imageResponse={imageResponse}
                                />
                            ) : tab === "documents" ? (
                                <div className="tab-active recomdn-table bg-grey-table">
                                    <Documents recommendationId={this.props.match.params.id} basicDetails={basicDetails} />
                                </div>
                            ) : tab === "checklists" ? (
                                <div className="add-recommendation tab-active recomdn-table bg-grey-table">
                                    <RecommendationChecklist data={this.state.checklistData} readOnly />
                                </div>
                            ) : tab === "capitalrequest" ? (
                                <div className="tab-active recomdn-table bg-grey-table">
                                    <CapitalRequest isRecommendationView isProjectView projectIdForSelection={basicDetails.project?.id || ""} />
                                </div>
                            ) : tab === "linked-recommendations" && basicDetails?.id ? (
                                <div className="tab-active recomdn-table bg-grey-table">
                                    <Recommendations
                                        isCrLinkedRecommendations
                                        recommendationDetails={basicDetails}
                                        projectIdForSmartChart={basicDetails.project?.id || ""}
                                    />
                                </div>
                            ) : tab === "linked-cr-recommendations" ? (
                                <div className="tab-active recomdn-table bg-grey-table">
                                    <Recommendations
                                        isCapitalRequest
                                        recommendationDetails={basicDetails}
                                        projectIdForSmartChart={basicDetails.project?.id || ""}
                                    />
                                </div>
                            ) : tab === "mobile-recommendations" ? (
                                <div className="tab-active recomdn-table bg-grey-table">
                                    <MobileRecommendationsMain
                                        isCapitalRequest
                                        recommendationDetails={basicDetails}
                                        projectIdForSmartChart={basicDetails.project?.id || ""}
                                        isNormalRecommendation={!isMobileRecommendation}
                                        parentLoading={this.state.loading}
                                    />
                                </div>
                            ) : tab === "qaqc" ? (
                                <div className="tab-active recomdn-table ">
                                    <QaQcBand
                                        showData={this.state.basicDetails?.showQaQcBand}
                                        recommendationId={this.props.match.params.id}
                                        basicDetails={basicDetails}
                                        isQaQcReviewerUser={this.state.basicDetails?.isQaQcReviewerUser}
                                        refreshinfoDetails={this.refreshinfoDetails}
                                        imageResponse={imageResponse}
                                        getAllImageList={getAllImageList}
                                    />
                                </div>
                            ) : tab === "softCosts" ? (
                                <SoftCosts projectId={basicDetails.project?.id || ""} basicDetails={basicDetails} />
                            ) : tab === "infoimages" ? (
                                <InfoImages
                                    setSelectedImage={this.setSelectedImage}
                                    selectedImage={this.state.selectedImage}
                                    uploadImages={this.uploadImages}
                                    imageList={this.state.imageList}
                                    deleteImage={this.deleteImage}
                                    updateImage={this.updateImage}
                                    refreshinfoDetails={this.refreshinfoDetails}
                                    locked={basicDetails.locked || basicDetails?.is_survey_lock}
                                    isBuildingLocked={this.props.isBuildingLocked}
                                    isDeleted={basicDetails.deleted}
                                    permissions={permissions}
                                    imageResponse={imageResponse}
                                    getAllImageList={getAllImageList}
                                    updateImageComment={this.props.updateRecommendationImageComment}
                                    deleteImages={this.props.deleteImages}
                                    hasCreate={checkPermission("forms", permissions.RECOMMENDATION_IMAGES, "create")}
                                    hasExport={checkPermission("forms", permissions.RECOMMENDATION_IMAGES, "export")}
                                    hasEdit={checkPermission("forms", permissions.RECOMMENDATION_IMAGES, "edit")}
                                    hasPullFromMasterImages={checkPermission("forms", permissions.RECOMMENDATION_IMAGES, "create")}
                                    handleAssignImagesFromMaster={this.handleAssignToRecom}
                                    entity={entities.RECOMMENDATIONS}
                                    basicDetails={basicDetails}
                                    hasDelete={checkPermission("forms", permissions.RECOMMENDATION_IMAGES, "delete")}
                                    updateImageSort={this.updateImageSort}
                                />
                            ) : null}
                            <div className="button-slide-outer">
                                <button
                                    className={`prev-btn ${
                                        !this.props.tableData?.length ||
                                        (this.props.tableData && this.state.basicDetails?.id === this.props.tableData[0]?.id)
                                            ? "cursor-diabled"
                                            : ""
                                    }`}
                                    disabled={
                                        !this.props.tableData?.length ||
                                        (this.props.tableData && this.state.basicDetails?.id === this.props.tableData[0]?.id)
                                    }
                                    onClick={() => this.handlePrev(basicDetails.id)}
                                    data-place="top"
                                    data-effect="solid"
                                    data-background-color="#007bff"
                                    data-tip="Previous"
                                    data-for="prv-nxt"
                                >
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <button
                                    className={`next-btn ${
                                        !this.props.tableData?.length ||
                                        (this.props.tableData &&
                                            this.state.basicDetails?.id === this.props.tableData[this.props.tableData?.length - 1]?.id)
                                            ? "cursor-diabled"
                                            : ""
                                    }`}
                                    disabled={
                                        !this.props.tableData?.length ||
                                        (this.props.tableData &&
                                            this.state.basicDetails?.id === this.props.tableData[this.props.tableData?.length - 1]?.id)
                                    }
                                    onClick={() => this.handleNext(basicDetails.id)}
                                    data-place="top"
                                    data-effect="solid"
                                    data-background-color="#007bff"
                                    data-tip="Next"
                                    data-for="prv-nxt"
                                >
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                                <ReactTooltip id="prv-nxt" />
                            </div>
                        </div>
                    </div>
                    {this.state.qaQcAddIssueModalFromInfoTabs && (
                        <Portal
                            body={<AddIssueModal onCancel={this.closeQaQcAddIssueModalFromInfoTabs} />}
                            onCancel={this.closeQaQcAddIssueModalFromInfoTabs}
                        />
                    )}
                    {this.state.qaQcReopenConfirmFromInfoTabs && (
                        <Portal
                            body={
                                <ConfirmationModal
                                    heading={
                                        getReviewGateStatus(this.props.recommendationsReducer?.getRecommendationByIdResponse) ===
                                        REVIEW_GATE_STATUS.QA_PASSED
                                            ? "This recommendation is marked as QA/QC Passed."
                                            : "This recommendation is marked as Ready for QA/QC."
                                    }
                                    message="Creating a new QA/QC issue will move this recommendation to Reopened. Are you sure you want to continue?"
                                    type="cancel"
                                    onNo={() => this.setState({ qaQcReopenConfirmFromInfoTabs: false })}
                                    onYes={() => {
                                        this.setState({
                                            qaQcAddIssueModalFromInfoTabs: true,
                                            qaQcReopenConfirmFromInfoTabs: false
                                        });
                                    }}
                                />
                            }
                            onCancel={() => this.setState({ qaQcReopenConfirmFromInfoTabs: false })}
                        />
                    )}
                </React.Fragment>
            </LoadingOverlay>
        );
    }
}

/** Same visibility rules as setTabs QA/QC entries; `basicDetails.isQaQcReviewerUser` is true for super_admin before API refresh. */
function getQaQcTabEntries(recommendationId, search, basicDetails, { showIndicator = true } = {}) {
    const isAssignedRecom = qs.parse(search || "")?.is_assignedRecom === "true";
    if ((localStorage.getItem("role") === "client_user" && !basicDetails?.isQaQcReviewerUser) || isAssignedRecom === "true") {
        return [];
    }
    const isMr = qs.parse(search || "")?.is_mr;
    const path = isMr
        ? `/recommendations/recommendationsinfo/${recommendationId}/qaqc?is_mr=true${search}`
        : `/recommendations/recommendationsinfo/${recommendationId}/qaqc${search}`;
    return [{ key: "qaqc", name: "QA/QC", showIndicator, path }];
}

const mapStateToProps = state => {
    const { recommendationStatusReducer, recommendationsReducer, projectReducer } = state;
    return {
        recommendationsReducer,
        recommendationStatusReducer,
        projectData: projectReducer.getProjectByIdResponse
    };
};

export default withRouter(
    connect(mapStateToProps, {
        ...statusActions
    })(RecommendationsInfo)
);
